import { AlocacoesQuery_alocacoes_professores_disciplina } from '../../graphql/queries/__generated__/AlocacoesQuery';

function formatar_sigla_disciplina(disciplina?: AlocacoesQuery_alocacoes_professores_disciplina) {
  return disciplina ? `${disciplina.dsc_sigla} (${disciplina.num_carga_horaria})` : '';
}

export { formatar_sigla_disciplina };
